export default function setCompanyId(companyId) {
	window.location.assign(`/?cid=${companyId}`);
}
